import type { InputChangeDetails } from "@9amhealth/wcl";
import type { FC } from "react";
import React, { useCallback } from "react";
import { useFormContext } from "react-hook-form";
import useQuestionnaireCubitInContext from "src/state/QuestionnaireCubit/useQuestionnaireCubitInContext";
import type { FormInputProps } from "src/ui/components/FormInput/FormInput";
import FormInput from "src/ui/components/FormInput/FormInput";
import resolveInputChangeValue from "src/ui/components/FormInput/resolveInputChangeValue";

const QuestionnaireTextInput: FC<FormInputProps> = (props) => {
  const [, { saveValue }] = useQuestionnaireCubitInContext();

  const {
    setError,
    formState: { errors }
  } = useFormContext();

  const handleChange = useCallback(
    (event: CustomEvent<InputChangeDetails>) => {
      props.onChange?.(event);

      const { name } = event.detail;
      const value = resolveInputChangeValue(event.detail, props.useMaskedValue);
      const parsedValue = props.parseValue ? props.parseValue(value) : value;
      const trimmedValue = parsedValue.trim();
      const validateError = event.detail.root?.validate(false);

      setTimeout(() => {
        if (!validateError) {
          saveValue(name, trimmedValue);
        } else {
          // clear value
          saveValue(name, "");
        }
        if (validateError) {
          setError(name, {
            type: "validate",
            message: validateError
          });
        }
      });
    },
    [errors]
  );

  return <FormInput {...props} onChange={handleChange} />;
};

export default QuestionnaireTextInput;
